import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core'; // ✅ Import du module
import { formatTokenAmount } from '../utils/formatters'; // <-- adapte le chemin




@Component({
  selector: 'app-token-selector',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './token-selector.component.html'
})

export class TokenSelectorComponent {
  @Input() userTokens: any[] = [];
  @Input() popularTokens: any[] = [];
  @Input() tokenBalances: Record<string, string> = {};
  @Input() priceMap: Record<string, number> = {};
  @Input() show: boolean = false;
  @Output() tokenSelected = new EventEmitter<string>();
  @Output() close = new EventEmitter<void>();
  @Input() dark: boolean = false;
  @Input() walletConnected: boolean = false;
  @Input() selectedCurrency: string = 'USD';
  @Input() fiatRates: Record<string, number> = { USD: 1 };
  @Input() mode: 'swap' | 'bridge' = 'swap';

  // 🔵 nouveau : thème piloté par le parent ("swap" violet / "bridge" bleu)
  
  searchQuery = '';
  formatTokenAmount = formatTokenAmount; // 🔥 expose la fonction au template
  filtered(tokens: any[]) {
    const q = this.searchQuery.toLowerCase();
    return tokens.filter(t =>
      t.symbol.toLowerCase().includes(q) || t.name?.toLowerCase().includes(q)
    );
  }
  get headerClass(): string {
    const value =
      this.mode === 'bridge'
        ? (this.dark ? 'text-blue-300' : 'text-blue-600')
        : (this.dark ? 'text-purple-300' : 'text-purple-600');
    return value;
  }




  selectToken(symbol: string) {
    this.tokenSelected.emit(symbol);
    this.close.emit();
  }

  unifiedTokens(): any[] {
    const seen = new Set();
    const merged = [...this.userTokens, ...this.popularTokens.filter(t => {
      if (seen.has(t.symbol)) return false;
      seen.add(t.symbol);
      return !this.userTokens.some(u => u.symbol === t.symbol);
    })];
    return this.filtered(merged);
  }

  getTokenFiatValue(token: any): number {
    const key = `${token.address.toLowerCase()}_${token.chainId}`;
    let priceUsd = this.priceMap[key] || 0;

    // ✅ Fallback stables si le prix n'est pas peuplé
    const sym = (token.symbol || '').toUpperCase();
    if (!priceUsd && ['USDC', 'USDT', 'DAI', 'EURC', 'USDE'].includes(sym)) {
      priceUsd = 1;
    }

    const raw = this.tokenBalances[key] || '0';
    const qty = parseFloat(raw) || 0;

    const rate = this.fiatRates[(this.selectedCurrency || 'USD').toUpperCase()] || 1;
    const value = qty * priceUsd * rate;

    // Arrondi propre
    return value > 0 ? +value.toFixed(2) : 0;
  }



}
